import React, { CSSProperties } from "react";
import { copyTextToClipboard } from "../tools/tools";

interface IProps {
  text: string;
  displayText?: string;
  style?: CSSProperties;
}

const CopyText: React.FC<IProps> = ({ text, displayText, style }) => {
  return (
    <span
      style={{ cursor: "pointer", ...style }}
      onClick={() => copyTextToClipboard(text)}
    >
      {displayText ? displayText : text}
    </span>
  );
};

export default CopyText;
